<template>
  <div>
    <horizontal-bars-chart
      :elements="plannedActions"
      elements-header-name="plannedActions"
      :bar-color="color"
      chart-type="planned"
      :loading="loading"
    />
  </div>
</template>

<script>
import HorizontalBarsChart from "./ChartTypes/HorizontalBarsChart.vue";

export default {
  components: {
    HorizontalBarsChart,
  },
  props: {
    plannedActions: {
      label: String,
      value: Number,
      percentage: Number,
    },
    loading: Boolean,
  },
  data: function () {
    return {
      color: "#f2ad3c",
    };
  },
};
</script>
